import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import extensionSuggestionsImg from "../../../../assets/images/blogs/pp26/extension-suggestions.png";
import extensionWarning from "../../../../assets/images/blogs/pp26/extension-warning.png";
import safeoverlays from "../../../../assets/images/blogs/pp26/overlays.png";
import insetviz from "../../../../assets/images/blogs/pp26/insetviz.png";
import confirmation from "../../../../assets/images/blogs/pp26/confirmation.png";
import measures from "../../../../assets/images/blogs/pp26/measures.png";
import labelwarning from "../../../../assets/images/blogs/pp26/label-warning.png";
import sessionname from "../../../../assets/images/blogs/pp26/session.png";
import hoststyling from "../../../../assets/images/blogs/pp26/hoststyling.png";
import colorpickercontextmenu from "../../../../assets/images/blogs/pp26/pickermenu.png";
import svhvideo from "../../../../assets/videos/blogs/pp26/svh.mp4";
import * as React from 'react';
export default {
  ShortCutDisplay,
  extensionSuggestionsImg,
  extensionWarning,
  safeoverlays,
  insetviz,
  confirmation,
  measures,
  labelwarning,
  sessionname,
  hoststyling,
  colorpickercontextmenu,
  svhvideo,
  React
};